import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "onboarding-banner",
  role: "alert"
}
const _hoisted_2 = { class: "onboarding-banner__content" }
const _hoisted_3 = { class: "onboarding-banner__info" }
const _hoisted_4 = { class: "onboarding-banner__message" }
const _hoisted_5 = { class: "onboarding-banner__actions" }

import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Icon } from "@iconify/vue";
import Button from "@/components/ui/Button.vue";
import { useOnboardingChecklist } from "@/composables/onboarding";
import { isOnboardingChecklistCompleted } from "@/utils/onboardingChecklistStorage";
import {
  isOnboardingBannerDismissedToday,
  isOnboardingBannerWindowExpired,
  dismissOnboardingBannerForToday,
  markOnboardingBannerFirstShown,
} from "@/utils/onboardingBannerStorage";
import { ONBOARDING_ROUTE } from "@/router/routes";
import { UserRoles } from "@/utils/enums";


export default /*@__PURE__*/_defineComponent({
  ...{
  name: "OnboardingBanner",
},
  __name: 'OnboardingBanner',
  setup(__props) {



const store = useStore();
const router = useRouter();

const account = computed(() => store.getters.account?.data);
const userId = computed(() => account.value?.id || "");
const organizationId = computed(() => account.value?.organizationId || null);
const isOwner = computed(() => account.value?.role === UserRoles.owner);

const checklistParams = computed(() =>
  organizationId.value
    ? { organizationId: organizationId.value, userId: userId.value, isOwner: isOwner.value }
    : null
);
const { steps, completedCount, isComplete, isLoading } = useOnboardingChecklist(checklistParams);
const totalSteps = computed(() => steps.value.length);

const dismissedThisVisit = ref(false);

// Only starts the 7-day window once we've confirmed (post-load) that onboarding is
// genuinely incomplete for this user — avoids anchoring the window to a moment where the
// checklist data just hasn't finished loading yet.
watch(
  isLoading,
  (loading) => {
    if (
      !loading &&
      userId.value &&
      !isComplete.value &&
      !isOnboardingChecklistCompleted(userId.value)
    ) {
      markOnboardingBannerFirstShown(userId.value);
    }
  },
  { immediate: true }
);

const showBanner = computed(() => {
  if (isLoading.value || dismissedThisVisit.value || !userId.value) return false;
  if (isComplete.value || isOnboardingChecklistCompleted(userId.value)) return false;
  if (isOnboardingBannerWindowExpired(userId.value)) return false;
  if (isOnboardingBannerDismissedToday(userId.value)) return false;
  return true;
});

const dismissBanner = () => {
  dismissOnboardingBannerForToday(userId.value);
  dismissedThisVisit.value = true;
};

const goToOnboarding = () => {
  router.push({ name: ONBOARDING_ROUTE });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "banner" }, {
    default: _withCtx(() => [
      (showBanner.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(Icon), {
                  icon: "mdi:rocket-launch-outline",
                  class: "onboarding-banner__icon"
                }),
                _createElementVNode("span", _hoisted_4, [
                  _cache[0] || (_cache[0] = _createTextVNode(" You're ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_unref(completedCount)) + "/" + _toDisplayString(totalSteps.value), 1),
                  _cache[1] || (_cache[1] = _createTextVNode(" of the way through setup — finish connecting your tools to get the most out of SalesBuckets. ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(Button, {
                  variant: "secondary",
                  size: "xs",
                  icon: "mdi:arrow-right",
                  "icon-position": "right",
                  class: "onboarding-banner__cta",
                  onClick: goToOnboarding
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" Continue Setup ", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("button", {
                  class: "onboarding-banner__dismiss",
                  onClick: dismissBanner,
                  "aria-label": "Dismiss"
                }, [
                  _createVNode(_unref(Icon), { icon: "mdi:close" })
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})